import * as NUMBER from 'constant/number'
import React, { useEffect } from 'react'
import { Row, Col, Form } from 'antd'
import Editor from 'view/component/editor'
import PropTypes from 'prop-types'
import TitleInput from 'view/component/form-items/title-input'
import ShortDescriptionInput from 'view/component/form-items/short-description-input'
import OrganisationSelect from 'view/component/form-items/article-org-select'
import CategorySelect from 'view/component/form-items/category-select'
import UpdateFrequencySelect from 'view/component/form-items/update-frequency-select'
import SpecialGroupSelect from 'view/component/form-items/article-special-group-select'
import PublishedSelect from 'view/component/form-items/published-select'
import Upload from 'view/component/form-items/upload'
import UserTypeSelect from 'view/component/form-items/article-user-type-select'
import TagSelect from 'view/component/form-items/tag-select'
import Email from 'view/component/form-items/send-email-select'
import Draft from 'view/component/form-items/draft'

const defaultFormValues = { published: false, send_emails: 'false' }

// eslint-disable-next-line max-lines-per-function
const DatasetForm = ({ dataset = defaultFormValues, form }) => {
  useEffect(() => {
    form.setFieldsValue(dataset)
  }, [dataset])
  return (
    <Row gutter={NUMBER.FIFTY}>
      <Col xl={NUMBER.EIGHT}>
        <Form
          form={form}
          layout='vertical'
          onFieldsChange={(changedFields) => {
            if (changedFields[0].name[0] === 'category_uuid') {
              form.setFieldsValue({ organisation_uuids: [], special: false, tag_uuid: [], user_type_uuids: [] })
            }
            if (changedFields[0].name[0] === 'special') {
              form.setFieldsValue({ user_type_uuids: [] })
            }
          }}
        >
          <TitleInput />
          <ShortDescriptionInput />
          <CategorySelect />
          <OrganisationSelect />
          <SpecialGroupSelect />
          <UserTypeSelect />
          <TagSelect />
          <UpdateFrequencySelect />
          <PublishedSelect />
          <Draft />
          <Upload fileName={dataset.image_name} />
          <Email />
        </Form>
      </Col>
      <Col xl={NUMBER.SIXTEEN}>
        <Editor
          form={form}
          insight={dataset}
        />

      </Col>
    </Row>
  )
}

DatasetForm.propTypes = {
  dataset: PropTypes.object,
  form: PropTypes.object
}

export default DatasetForm
